import React from 'react';

export const TransactionTabs = ({ selectedTab, handleTabChange }) => {
  const tabs = ['deposit', 'withdraw', 'transfer', 'swap'];

  return (
    <div className="flex justify-between items-center border-b border-white/20 mb-4">
      <div className="flex space-x-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabChange(tab)}
            className={`px-3 py-2 transition-all duration-150 font-medium ${
              selectedTab === tab
                ? 'text-[#efefef] border-b-2 border-[#efefef]'
                : 'text-white/50 hover:text-white'
            }`}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};
